import { TranslationObject } from '@ngx-translate/core';
import { Tag } from '@lib.core/entities/tag/tag';

export interface TagDTO {
  id: number;
  nameid: string;
  title: TranslationObject;
  createdAt?: string;
  lastUpdatedAt?: string;
}

export interface TagSaveDTO {
  nameid: string;
  title: TranslationObject;
}

export function newTagFromDto(tagDTO: TagDTO | undefined): [Tag, Error | null] {
  if (tagDTO?.nameid === undefined || tagDTO?.title === undefined) {
    return [new Tag(0, '', {}, new Date()), new Error('no proper Tag is provided')];
  }
  const createdAt = tagDTO.createdAt ? new Date(tagDTO.createdAt) : undefined;
  const lastUpdatedAt = tagDTO.lastUpdatedAt ? new Date(tagDTO.lastUpdatedAt) : undefined;
  return [new Tag(tagDTO.id, tagDTO.nameid, tagDTO.title, createdAt, lastUpdatedAt), null];
}

export function toTagDTO(tag: Tag): TagDTO {
  const { id, nameId, title, createdAt, lastUpdatedAt } = tag;
  return {
    id,
    nameid: nameId,
    title,
    createdAt: createdAt?.toISOString(),
    lastUpdatedAt: lastUpdatedAt?.toISOString(),
  }
}
